module.exports = __webpack_public_path__ + "img/10T_510k_otc.42a0e600.jpg";